<template>
  <button
    class="w-4"
    data-testid="mainMenuButton"
    :aria-label="$t('Open main menu')"
    @click="toggleNavigation"
  >
    <span
      class="text-sm"
      :class="isNavigationOpen ?
        'iconify svg--menu-close text-EXPONDO-orange' :
        'iconify svg--burger-menu text-EXPONDO-primary'"
    />
  </button>
</template>
<script lang="ts">

import type { Category } from '~~/types/commercetools';

export default defineComponent({
  name: 'NavMainBarAllCategoriesButton',
  props: {
    categoriesContainer: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
  },
  setup() {

    const {
      toggleNavigation,
      isNavigationOpen,
    } = useNavigationState();

    return {
      toggleNavigation,
      isNavigationOpen,
    };
  
  },
});

</script>
